export var printReceiptTestData = {
    id: 1,
    fact_new_invoice_id: 1,
    dim_mst_receipt_status_id: 2,
    dim_mst_payment_type_id: 1,
    dim_mst_price_category_id: 1,
    dim_new_alldernow_emp_id: 96,
    fact_member_id: 4,
    doc_number: "RE-250700001",
    invoice_doc_number_ref: "IVT-250700001",
    full_member_name: "ร้านค้า หลง คาเฟ่",
    full_member_address_name: "179  ม.6 ต.หัวง้ม อ.หัวง้ม จ.เชียงราย 57120",
    member_is_hq: false,
    member_branch_no: null,
    member_additional_info: null,
    member_business_type: null,
    member_customer_type: "ร้านค้า",
    member_address: "179  ม.6",
    member_district: "หัวง้ม",
    member_amphoe: "หัวง้ม",
    member_province: "เชียงราย",
    member_postal_code: "57120",
    member_phone_number: "0615197449",
    dim_branch_id: 3,
    refer: "",
    dim_mst_discount_type_id: 1,
    discount_value: 0,
    total_price_before_discount: 7998.25,
    discount_price: 0,
    total_price_after_discount: 7998.25,
    total_price_product_no_vat: 0,
    total_price_product_zero_vat: 0,
    total_price_product_seven_vat: 7475,
    total_seven_vat_amount: 523.25,
    total_price_vat: 523.25,
    total_price_before_vat: 7475,
    grand_total_price: 7998.25,
    sum_item_quantity: 10,
    remark: "",
    doc_issue_date: "2025-07-01T00:00:00.000Z",
    doc_due_date: "2025-07-03T00:00:00.000Z",
    is_sort_manual: false,
    is_tax_receipt: true,
    not_approve_reason: "",
    canceled_at: null,
    canceled_by_emp_id: null,
    updated_wait_approve_at: null,
    updated_approve_at: "2025-07-01T09:25:33.000Z",
    updated_success_at: null,
    created_at: "2025-07-01T03:41:19.000Z",
    updated_at: "2025-07-01T09:25:32.000Z",
    dimMstDiscountType: {
        id: 1,
        name: "%",
        is_active: true,
        created_at: "2024-05-11T00:51:19.000Z",
        updated_at: "2024-05-11T00:51:19.000Z"
    },
    factNewReceiptItem: [
        {
            id: 3,
            fact_new_receipt_id: 1,
            fact_new_invoice_item_id: 1,
            dim_product_price_id: 21507,
            unit_id: 2,
            ratio_unit: 12,
            container: "1x12",
            quantity: 5,
            avg_discount_before_vat: 1425,
            unit_price: 1500,
            dim_mst_discount_type_id: 1,
            discount_value: 5,
            discount_price: 75,
            dim_mst_vat_id: 3,
            total_price_before_vat: 7125,
            total_price_include_vat: 7623.75,
            remark: null,
            created_at: "2025-07-01T09:25:32.000Z",
            updated_at: "2025-07-01T09:25:32.000Z",
            dimMasterUnit: {
                id: 2,
                name: "ลัง",
                desc: "ลัง",
                is_active: true,
                created_at: "2021-05-05T13:38:04.000Z",
                updated_at: "2021-05-05T13:38:04.000Z"
            },
            dimMstVat: {
                id: 3,
                name: "7 %",
                value: 7,
                is_active: true,
                created_at: "2024-05-11T00:51:19.000Z",
                updated_at: "2024-05-11T00:51:19.000Z"
            },
            dimProductPrice: {
                id: 21507,
                product_id: 7223,
                barcode: "885929611X12",
                code_sales: null,
                price_1: 1560,
                price_2: null,
                price_3: null,
                price_4: null,
                price_5: null,
                unit_id: 2,
                ratio_unit: 12,
                container: "1x12",
                is_new: false,
                is_new_sort: 0,
                is_hot: false,
                is_hot_sort: 0,
                is_web: false,
                width: 0,
                length: 0,
                height: 0,
                weight: 0,
                weight_name: null,
                is_web_flash_sales: false,
                price_flash_sales: 0,
                number_per_person_flash_sales: 0,
                number_per_product: 0,
                number_flash_sales_use: 0,
                is_come_on: false,
                is_promotion_web: false,
                promotion_web_discount: 0,
                is_delete: false,
                created_at: "2024-05-14T08:07:17.000Z",
                updated_at: "2024-05-14T08:10:36.000Z",
                deleted_at: null,
                dimProduct: {
                    id: 7223,
                    sku: "12233",
                    barcode: "885929611",
                    name_th: "ยูยี ผงโกโก้ 500g.+ซันเดย์ช็อกโกแลตท้อปปิ้ง 600g.",
                    name_en: "ยูยี ผงโกโก้ 500g.+ซันเดย์ช็อกโกแลตท้อปปิ้ง 600g.",
                    supplier_names: [
                        "ทดสอบชื่อ"
                    ],
                    supplier_code: "ABC123",
                    formula_id: null,
                    family_id: null,
                    category_id: 1,
                    sub_category_id: 1,
                    sub_category_2_id: 2,
                    divition_id: null,
                    brand_id: 17,
                    desc: null,
                    sub_unit_id: 21,
                    unit_id: 2,
                    ratio_sub_unit: 12,
                    sub_unit_cost: 100,
                    unit_cost: 1200,
                    vat: "VAT 7%",
                    minimum_sales: null,
                    packing_size_name_th: null,
                    packing_size_th: null,
                    packing_size_name_en: null,
                    packing_size_en: null,
                    registration_number: null,
                    tisi: null,
                    weight: null,
                    weight_name: null,
                    wide: null,
                    long: null,
                    height: null,
                    dimension_unit: null,
                    storage_id: null,
                    initial_product_quantity: null,
                    minimum_alert: null,
                    over_stock: null,
                    is_able_sell_negative: null,
                    remark: null,
                    user_id: 34,
                    is_web: false,
                    is_closed: false,
                    is_delete: false,
                    created_at: "2024-05-14T08:07:17.000Z",
                    updated_at: "2025-03-14T16:33:43.000Z",
                    deleted_at: null
                }
            }
        },
        {
            id: 4,
            fact_new_receipt_id: 1,
            fact_new_invoice_item_id: 2,
            dim_product_price_id: 21506,
            unit_id: 21,
            ratio_unit: 1,
            container: "1x1",
            quantity: 5,
            avg_discount_before_vat: 70,
            unit_price: 120,
            dim_mst_discount_type_id: 2,
            discount_value: 50,
            discount_price: 50,
            dim_mst_vat_id: 3,
            total_price_before_vat: 350,
            total_price_include_vat: 374.5,
            remark: null,
            created_at: "2025-07-01T09:25:32.000Z",
            updated_at: "2025-07-01T09:25:32.000Z",
            dimMasterUnit: {
                id: 21,
                name: "ชุด",
                desc: "ชุด",
                is_active: true,
                created_at: "2021-05-09T14:21:29.000Z",
                updated_at: "2021-05-09T14:21:29.000Z"
            },
            dimMstVat: {
                id: 3,
                name: "7 %",
                value: 7,
                is_active: true,
                created_at: "2024-05-11T00:51:19.000Z",
                updated_at: "2024-05-11T00:51:19.000Z"
            },
            dimProductPrice: {
                id: 21506,
                product_id: 7223,
                barcode: "885929611",
                code_sales: null,
                price_1: 130,
                price_2: null,
                price_3: null,
                price_4: null,
                price_5: null,
                unit_id: 21,
                ratio_unit: 1,
                container: "1x1",
                is_new: false,
                is_new_sort: 0,
                is_hot: false,
                is_hot_sort: 0,
                is_web: false,
                width: 0,
                length: 0,
                height: 0,
                weight: 0,
                weight_name: null,
                is_web_flash_sales: false,
                price_flash_sales: 0,
                number_per_person_flash_sales: 0,
                number_per_product: 0,
                number_flash_sales_use: 0,
                is_come_on: false,
                is_promotion_web: false,
                promotion_web_discount: 0,
                is_delete: false,
                created_at: "2024-05-14T08:07:17.000Z",
                updated_at: "2024-05-14T08:10:36.000Z",
                deleted_at: null,
                dimProduct: {
                    id: 7223,
                    sku: "12233",
                    barcode: "885929611",
                    name_th: "ยูยี ผงโกโก้ 500g.+ซันเดย์ช็อกโกแลตท้อปปิ้ง 600g.",
                    name_en: "ยูยี ผงโกโก้ 500g.+ซันเดย์ช็อกโกแลตท้อปปิ้ง 600g.",
                    supplier_names: [
                        "ทดสอบชื่อ"
                    ],
                    supplier_code: "ABC123",
                    formula_id: null,
                    family_id: null,
                    category_id: 1,
                    sub_category_id: 1,
                    sub_category_2_id: 2,
                    divition_id: null,
                    brand_id: 17,
                    desc: null,
                    sub_unit_id: 21,
                    unit_id: 2,
                    ratio_sub_unit: 12,
                    sub_unit_cost: 100,
                    unit_cost: 1200,
                    vat: "VAT 7%",
                    minimum_sales: null,
                    packing_size_name_th: null,
                    packing_size_th: null,
                    packing_size_name_en: null,
                    packing_size_en: null,
                    registration_number: null,
                    tisi: null,
                    weight: null,
                    weight_name: null,
                    wide: null,
                    long: null,
                    height: null,
                    dimension_unit: null,
                    storage_id: null,
                    initial_product_quantity: null,
                    minimum_alert: null,
                    over_stock: null,
                    is_able_sell_negative: null,
                    remark: null,
                    user_id: 34,
                    is_web: false,
                    is_closed: false,
                    is_delete: false,
                    created_at: "2024-05-14T08:07:17.000Z",
                    updated_at: "2025-03-14T16:33:43.000Z",
                    deleted_at: null
                }
            }
        }
    ],
    factItemReceiptColSort: [],
    factTagReceipt: [],
    factDocFileReceipt: [],
    createdNewReceiptEmp: {
        id: 96,
        dim_mst_prefix_id: 1,
        dim_mst_sex_id: null,
        dim_mst_marital_status_id: null,
        dim_mst_military_status_id: null,
        dim_branch_id: 3,
        emp_code: "SPADMIN01",
        img_path: "media/dim-new-alldernow-emp/1712585961547-118698994.jpg",
        first_name_th: "ซุปเปอร์แอดมิน",
        last_name_th: "ซุปเปอร์แอดมิน",
        first_name_en: "test",
        last_name_en: "eng",
        id_card: null,
        nick_name: null,
        birth_date: null,
        age: null,
        ethnicity: null,
        nationality: null,
        dim_mst_relationship_id: null,
        address: "123 ถนนทดสอบ",
        sub_district: null,
        district: null,
        province: null,
        postal_code: null,
        email: "superadmin@admin.com",
        phone_number: null,
        line: null,
        facebook: null,
        instagram: null,
        emergency_contact_person: null,
        emergency_phone_number: null,
        dim_mst_bank_id: null,
        dim_mst_bank_account_type_id: null,
        is_bank_account: false,
        bank_account_name: null,
        bank_account_number: null,
        bank_account_branch_name: null,
        bank_account_branch_number: null,
        dim_mst_employee_type_id: null,
        dim_mst_department_id: null,
        dim_mst_position_id: null,
        start_date: "2024-04-10T00:00:00.000Z",
        end_date: null,
        is_register_social_security: false,
        cancel_by_user_id: null,
        deleted_at: null,
        created_at: "2024-04-02T01:37:42.000Z",
        updated_at: "2024-04-08T14:19:22.000Z"
    },
    dimMstReceiptStatus: {
        id: 2,
        name: "เสร็จสิ้น",
        is_active: true,
        created_at: "2025-07-01T10:37:27.000Z",
        updated_at: "2025-07-01T10:37:27.000Z"
    },
    factMember: {
        id: 4,
        customer_id: "CM2021050004",
        customer_type: "ร้านค้า",
        tax_id: "",
        prefix_name: "",
        first_name: "",
        last_name: "",
        prefix_comp_name: "ร้านค้า",
        comp_name: "หลง คาเฟ่",
        comp_last_name: null,
        phone_number: "0615197449",
        new_phone_number: null,
        birth_date: null,
        group_customer: null,
        price_type: null,
        business_name: null,
        bussiness_type: null,
        point: 6254,
        junecoin: 0,
        register_form: "Line LIFF",
        cti_tax_id: null,
        is_cti_hq: null,
        cti_branch_no: null,
        additional_info: null,
        cti_type: null,
        cti_prefix: null,
        cti_name: null,
        cti_suffix: null,
        cti_email: null,
        cti_address: "179  ม.6",
        cti_district: "หัวง้ม",
        cti_amphoe: "หัวง้ม",
        cti_province: "เชียงราย",
        cti_postal_code: null,
        pti_tax_id: "1570500016261",
        pti_type: null,
        pti_prefix: null,
        pti_firstname: null,
        pti_lastname: null,
        pti_co_prefix: null,
        pti_co_name: null,
        pti_co_suffix: null,
        pti_email: null,
        pti_address: "179  ม.6",
        pti_district: "หัวง้ม",
        pti_amphoe: "หัวง้ม",
        pti_province: "เชียงราย",
        pti_postal_code: "57120",
        is_bo_sale: true,
        created_at: "2021-05-21T01:14:37.000Z",
        updated_at: "2023-07-08T05:06:39.000Z"
    },
    dimMstPaymentType: {
        id: 1,
        name: "เงินสด",
        is_active: true,
        created_at: "2024-05-11T00:51:19.000Z",
        updated_at: "2024-05-11T00:51:19.000Z"
    },
    factNewInvoice: {
        id: 1,
        fact_new_do_id: 13,
        dim_mst_invoice_status_id: 5,
        dim_mst_payment_type_id: 1,
        dim_mst_price_category_id: 1,
        dim_new_alldernow_emp_id: 96,
        fact_member_id: 4,
        doc_number: "IVT-250700001",
        do_doc_number_ref: "DO-250600013",
        full_member_name: "ร้านค้า หลง คาเฟ่",
        full_member_address_name: "179  ม.6 ต.หัวง้ม อ.หัวง้ม จ.เชียงราย 57120",
        member_is_hq: false,
        member_branch_no: null,
        member_additional_info: null,
        member_business_type: null,
        member_customer_type: "ร้านค้า",
        member_address: "179  ม.6",
        member_district: "หัวง้ม",
        member_amphoe: "หัวง้ม",
        member_province: "เชียงราย",
        member_postal_code: "57120",
        member_phone_number: "0615197449",
        dim_branch_id: 3,
        refer: "",
        dim_mst_discount_type_id: 1,
        discount_value: 0,
        total_price_before_discount: 7998.25,
        discount_price: 0,
        total_price_after_discount: 7998.25,
        total_price_product_no_vat: 0,
        total_price_product_zero_vat: 0,
        total_price_product_seven_vat: 7475,
        total_seven_vat_amount: 523.25,
        total_price_vat: 523.25,
        total_price_before_vat: 7475,
        grand_total_price: 7998.25,
        total_paid_price: 7998.25,
        total_outstanding_price: 0,
        sum_item_quantity: 10,
        remark: "",
        doc_issue_date: "2025-07-01T00:00:00.000Z",
        doc_due_date: "2025-07-03T00:00:00.000Z",
        is_sort_manual: false,
        is_tax_invoice: true,
        is_submitted: true,
        is_receipt_created: true,
        not_approve_reason: "",
        canceled_at: null,
        canceled_by_emp_id: null,
        updated_wait_approve_at: "2025-07-01T03:44:16.000Z",
        updated_approve_at: "2025-07-01T04:20:42.000Z",
        submitted_at: "2025-07-01T04:36:55.000Z",
        updated_success_at: null,
        created_at: "2025-07-01T03:41:19.000Z",
        updated_at: "2025-07-01T09:25:14.000Z",
        dimMstInvoiceStatus: {
            id: 5,
            name: "ชำระแล้ว",
            is_active: true,
            created_at: "2025-06-09T14:13:38.000Z",
            updated_at: "2025-07-01T10:37:27.000Z"
        },
        createdNewInvoiceEmp: {
            id: 96,
            dim_mst_prefix_id: 1,
            dim_mst_sex_id: null,
            dim_mst_marital_status_id: null,
            dim_mst_military_status_id: null,
            dim_branch_id: 3,
            emp_code: "SPADMIN01",
            img_path: "media/dim-new-alldernow-emp/1712585961547-118698994.jpg",
            first_name_th: "ซุปเปอร์แอดมิน",
            last_name_th: "ซุปเปอร์แอดมิน",
            first_name_en: "test",
            last_name_en: "eng",
            id_card: null,
            nick_name: null,
            birth_date: null,
            age: null,
            ethnicity: null,
            nationality: null,
            dim_mst_relationship_id: null,
            address: "123 ถนนทดสอบ",
            sub_district: null,
            district: null,
            province: null,
            postal_code: null,
            email: "superadmin@admin.com",
            phone_number: null,
            line: null,
            facebook: null,
            instagram: null,
            emergency_contact_person: null,
            emergency_phone_number: null,
            dim_mst_bank_id: null,
            dim_mst_bank_account_type_id: null,
            is_bank_account: false,
            bank_account_name: null,
            bank_account_number: null,
            bank_account_branch_name: null,
            bank_account_branch_number: null,
            dim_mst_employee_type_id: null,
            dim_mst_department_id: null,
            dim_mst_position_id: null,
            start_date: "2024-04-10T00:00:00.000Z",
            end_date: null,
            is_register_social_security: false,
            cancel_by_user_id: null,
            deleted_at: null,
            created_at: "2024-04-02T01:37:42.000Z",
            updated_at: "2024-04-08T14:19:22.000Z"
        }
    },
    canceledByEmp: null,
    dimMstBranch: {
        id: 3,
        branch_code: "PYO-001",
        name: "สำนักงานใหญ่",
        address: "71/321",
        district: "ตลาดขวัญ",
        amphoe: "เมืองนนทบุรี",
        province: "นนทบุรี",
        postal_code: "11000",
        url_google_map: null,
        warehouse_id: 3,
        created_at: "2021-09-29T02:47:50.000Z",
        updated_at: "2024-07-24T16:54:03.000Z",
        is_head_office: true,
        revenue_department_number: "00000",
        dimBranchPaymentChannel: [
            {
                id: 5,
                dim_mst_payment_channel_id: 1,
                dim_mst_bank_id: null,
                dim_branch_id: 3,
                bank_account_name: null,
                bank_branch: null,
                account_type: null,
                account_number: null,
                is_active: true,
                created_at: "2025-07-01T10:37:27.000Z",
                updated_at: "2025-07-01T10:37:27.000Z",
                dimMstBank: null
            },
            {
                id: 6,
                dim_mst_payment_channel_id: 2,
                dim_mst_bank_id: 2,
                dim_branch_id: 3,
                bank_account_name: "บจก.ค้าขายมั่งมี จำกัด",
                bank_branch: "ถนนแจ้งวัฒนะ",
                account_type: "กระแสรายวัน",
                account_number: "203-1-87899-6",
                is_active: true,
                created_at: "2025-07-01T10:37:27.000Z",
                updated_at: "2025-07-01T10:37:27.000Z",
                dimMstBank: {
                    id: 2,
                    logo_path: "banks/KBANK.png",
                    name: "กสิกรไทย",
                    is_active: true,
                    created_at: "2024-04-02T01:37:42.000Z",
                    updated_at: "2025-07-01T10:37:27.000Z"
                }
            }
        ]
    }
};
